
export const EXCHNAGE_URL = 'https://api.awardsuite.in/api/admin'
// export const EXCHNAGE_URL = 'http://localhost:3000/api/admin'

export const USER_EXCHNAGE_URL = 'https://api.awardsuite.in/api/user'
// export const USER_EXCHNAGE_URL = 'http://localhost:3000/api/user'

export const IMAGES_URL = 'https://api.awardsuite.in/uploads/'
// export const IMAGES_URL = 'http://localhost:3000/uploads/'
   
export const EXCHNAGE_URL_JUDGE = 'https://api.awardsuite.in/api/judge'
      
export const EXHANGE_URL_EVENT_PAGE = 'https://api.awardsuite.in'

  
export const EXHANGE_URL_IMAGE_UPLOAD = 'https://api.awardsuite.in/api'
   
export const EXCHNAGE_UR_PAYMENTSL = 'https://api.awardsuite.in/api/payments'
// //    
 

// export const EXCHNAGE_URL = 'https://judgify-api.phanomprofessionals.com/api/admin'
// export const EXCHNAGE_URL = 'http://localhost:3001/api/admin'

// // export const USER_EXCHNAGE_URL = 'https://judgify-api.phanomprofessionals.com/api/user'
// export const USER_EXCHNAGE_URL = 'http://localhost:3001/api/user'

// export const IMAGES_URL = 'http://localhost:3001/uploads/'
// // export const IMAGES_URL = 'http://localhost:3001/uploads/'

// export const EXCHNAGE_URL_JUDGE = 'http://localhost:3001/api/judge'


// export const EXHANGE_URL_IMAGE_UPLOAD = 'http://localhost:3001/api'


// export const EXHANGE_URL_EVENT_PAGE = 'http://localhost:3001'


// export const EXCHNAGE_UR_PAYMENTSL = 'http://localhost:3001/api/payments'  